import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useIsElementInViewport } from 'shared/hooks/useIsElementInViewport';

import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { IConstructorResult } from 'shared/types/ConstructorResult';
import ProductListTableRow from './ProductListTableRow';

/**
 * [ProductListTable]
 *  displays a Table of product details
 * @param {Object} curatedLinks A list of 4 products.
 */

interface IProductListTable {
  moduleTrackingData: IModuleTrackingData;
  products: IConstructorResult[];
  pageOffset?: number;
}

export const ProductListTable = ({
  moduleTrackingData,
  products,
  pageOffset = 0,
}: IProductListTable) => {
  const moduleRef = useRef();
  const initialInViewport = useIsElementInViewport(moduleRef);
  const [isModuleInViewport, setIsModuleInViewport] = useState(initialInViewport);

  const handleClick = (product, index = 0) => {
    const relativeIndex = pageOffset + index;

    sendTrackingEvent('CMS_MODULE_ITEM_TAP', {
      ...moduleTrackingData,
      item_position: relativeIndex,
      product_template_slug: product?.data.slug,
    });
  };

  useEffect(() => {
    if (!isModuleInViewport) {
      setIsModuleInViewport(initialInViewport);
    }
  }, [initialInViewport, isModuleInViewport]);

  return (
    <ProductListTable.Wrapper ref={moduleRef}>
      <ProductListTable.Table>
        <tbody>
          {products.map((product, index) => (
            <ProductListTableRow
              key={`${product?.value}-${Number.parseInt(product?.data?.id, 10) * index}`}
              product={product}
              onClick={() => handleClick(product, index)}
              isModuleInViewport={isModuleInViewport}
            />
          ))}
        </tbody>
      </ProductListTable.Table>
    </ProductListTable.Wrapper>
  );
};

ProductListTable.Wrapper = styled.div``;
ProductListTable.Table = styled.table`
  overflow: hidden;
  margin: 0;
  padding: 0;
  margin-right: 24px;
  min-width: 310px;
  width: 25%;

  &:first-child {
    border-top: ${({ theme }) => theme.borders.white};
  }
`;
